import Participate from './Participate';
export default Participate;
